import http from "@/assets/js/http.js";
import modal from "@/assets/js/modal.js";
import helper from "@/assets/js/helper.js";

const state = () => ({
    filter: {
        requested: false,
        id_perusahaan: [],
        id_salesman: [],
        id_tim: [],
        status: 'all',
        start_date: helper.methods.dateTime('ymd'),
        end_date: helper.methods.dateTime('ymd'),
    },
    response: {
        data: {
            start_date : "",
            end_date : "",
            detail : {},
            penjualan : [],
            invoice : [],
            subtotal : {},
            grand_total : {},
            depo : "",
            perusahaan : "",
            driver : "",
            salesman : "",
        },
        meta: [],
        filter: {
            depos: [],
            drivers: [],
            salesmans: [],
            perusahaans: [],
        },
    },
    modal: {
        filter: {
            backdrop: false,
            modal: false,
            data: {},
        }
    },
})

const mutations = {
}

const actions = {
    triggerModal({ state }, payload) {
        return modal.trigger(state, payload)
    },
    getRekapitulasiDo({ state }, payload = null) {
        return http.get('report/rekapitulasi_do', state, payload)
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
